export default __webpack_public_path__ + "locales/fi/InfoPanel.json?hash=5c9b4904aa28c182dcfbc50ce5ece185";